/* tslint:disable */
/* eslint-disable */
/**
 * Pyrra
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Query,
    QueryFromJSON,
    QueryFromJSONTyped,
    QueryToJSON,
} from './Query';

/**
 * 
 * @export
 * @interface IndicatorRatio
 */
export interface IndicatorRatio {
    /**
     * 
     * @type {Query}
     * @memberof IndicatorRatio
     */
    errors: Query;
    /**
     * 
     * @type {Query}
     * @memberof IndicatorRatio
     */
    total: Query;
    /**
     * 
     * @type {Array<string>}
     * @memberof IndicatorRatio
     */
    grouping?: Array<string>;
}

export function IndicatorRatioFromJSON(json: any): IndicatorRatio {
    return IndicatorRatioFromJSONTyped(json, false);
}

export function IndicatorRatioFromJSONTyped(json: any, ignoreDiscriminator: boolean): IndicatorRatio {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'errors': QueryFromJSON(json['errors']),
        'total': QueryFromJSON(json['total']),
        'grouping': !exists(json, 'grouping') ? undefined : json['grouping'],
    };
}

export function IndicatorRatioToJSON(value?: IndicatorRatio | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'errors': QueryToJSON(value.errors),
        'total': QueryToJSON(value.total),
        'grouping': value.grouping,
    };
}

